export default __webpack_public_path__ + "static/media/logo-para.efe4c7ab.svg";